import React, { FC, useEffect } from 'react'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { NavLink } from 'react-router-dom'
import s from './PrivacyPolicy.module.scss'
import { Helmet } from 'react-helmet-async'
import { scrollToTop } from '../../utils'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { fetchPrivacyPolicy } from '../../store/slices/privacyPolicySlice'
import Loader from '../../components/Loader/Loader'
import ReactMarkdown from 'react-markdown'

const PrivacyPolicy: FC = () => {
    const dispatch = useAppDispatch()
    const { content, loading } = useAppSelector(state => state.privacyPolicy)

    useEffect(() => {
        scrollToTop()
        dispatch(fetchPrivacyPolicy())
    }, [dispatch])

    return (
        <>
        <Helmet>
            <title>
                Политика конфиденциальности | Phoenix Programs
            </title>

            <meta
                name="description"
                content="Политика конфиденциальности Phoenix Programs. Информация о сборе, обработке и защите персональных данных пользователей."
            />

            <link rel="canonical" href="https://phoenix-programs.ru/privacy-policy" />

            {/* Open Graph */}
            <meta property="og:type" content="article" />
            <meta property="og:locale" content="ru_RU" />
            <meta property="og:url" content="https://phoenix-programs.ru/privacy-policy" />
            <meta
                property="og:title"
                content="Политика конфиденциальности | Phoenix Programs"
            />
            <meta
                property="og:description"
                content="Официальная политика обработки и защиты персональных данных компании Phoenix Programs."
            />
            <meta
                property="og:image"
                content="https://phoenix-programs.ru/logo192.png"
            />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta
                name="twitter:title"
                content="Политика конфиденциальности | Phoenix Programs"
            />
            <meta
                name="twitter:description"
                content="Информация о сборе и защите персональных данных."
            />
            <meta
                name="twitter:image"
                content="https://phoenix-programs.ru/logo192.png"
            />

            <meta name="robots" content="index, follow" />
        </Helmet>

            <TopBanner title='Политика конфиденциальности' />
            <Breadcrumbs>
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/'}>Главная</NavLink>
                /
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/privacy-policy'}>Политика конфиденциальности</NavLink>
            </Breadcrumbs>
            <section className={s.section}>
                <div className={`${s.container} container`}>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className={s.content}>
                            <ReactMarkdown>{content || ''}</ReactMarkdown>
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}

export default PrivacyPolicy


